(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name commons.directive:typeaheadDirective
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
     <example module="commons">
       <file name="index.html">
        <typeahead-directive></typeahead-directive>
       </file>
     </example>
   *
   */
  angular
    .module('commons')
    .directive('typeahead', typeahead);

  function typeahead() {
      return {
          require: 'ngModel',
          link: function (scope, element, attr, ctrl) {
              element.off('mousedown').on('mousedown', function () {
                  ctrl.$setViewValue('');
              });
              element.off('mouseup').on('mouseup', function () {
                  this.value='';
                  ctrl.$setViewValue(' ');
              });
          }
      };
  }
}());
